var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmationInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_2906_22982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 0C8.07 0 0 8.07 0 18C0 27.93 8.07 36 18 36C27.93 36 36 27.93 36 18C36 8.07 27.93 0 18 0ZM33.63 18C33.63 26.62 26.62 33.63 18 33.63C9.38 33.63 2.37 26.62 2.37 18C2.37 9.38 9.38 2.37 18 2.37C26.62 2.37 33.63 9.38 33.63 18Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.0001 6.79004C17.0001 6.79004 16.1901 7.60004 16.1901 8.60004L16.5501 21.98C16.5501 22.78 17.2001 23.43 18.0001 23.43C18.8001 23.43 19.4501 22.78 19.4501 21.98L19.8101 8.60004C19.8101 7.60004 19.0001 6.79004 18.0001 6.79004ZM18.0001 24.87C16.8001 24.87 15.8301 25.84 15.8301 27.04C15.8301 28.24 16.8001 29.21 18.0001 29.21C19.2001 29.21 20.1701 28.24 20.1701 27.04C20.1701 25.84 19.2001 24.87 18.0001 24.87Z",
    fill: "#FFC107"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2906_22982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationInfo);
export default __webpack_public_path__ + "static/media/confirmationInfo.6740b50a4828aded7756aa51d69ddba4.svg";
export { ForwardRef as ReactComponent };